<template>
    <span>
        {{ time | secondsToTimeFormat }}
    </span>
</template>

<script>
import moment from "moment";
export default {
    props: {
        item: {
            type: Object
        }
    },
    data() {
        return { time: null, interval: null };
    },
    created() {
        this.interval = setInterval(this.getTime, 1000);
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    methods: {
        getTime() {
            this.time = moment().diff(this.item.created_at, "seconds");
        }
    }
};
</script>

<style></style>
